import{gql as e}from"@apollo/client";const t=e`
  mutation deleteGeladaProject($projectId: String!) {
    project {
      deleteGeladaProject: deleteProject(projectId: $projectId)
    }
  }
`;export{t as DELETE_GELADA_PROJECT_MUTATION};
//# sourceMappingURL=useDeleteGeladaProject.graphql.js.map
